<div class="p-4">
  <h1 class="mb-6 text-2xl font-semibold">Activation keys</h1>

  <div class="mb-8 mt-4 flex flex-wrap gap-4">
    <label class="form-control min-w-[12rem]">
      <div class="label">
        <span class="label-text">Account Number</span>
      </div>
      <input
        type="text"
        class="input input-bordered"
        [(ngModel)]="accountNumber"
        (keydown.enter)="search(); $event.preventDefault()"
      />
    </label>
    <label class="form-control min-w-[12rem]">
      <div class="label">
        <span class="label-text">Created by (user)</span>
      </div>
      <input
        type="text"
        class="input input-bordered"
        [(ngModel)]="createdBy"
        (keydown.enter)="search(); $event.preventDefault()"
        placeholder="Username or email"
      />
    </label>
    <label class="form-control min-w-[12rem]">
      <div class="label">
        <span class="label-text">Created from</span>
      </div>
      <input
        type="date"
        class="input input-bordered"
        [(ngModel)]="createdAfter"
      />
    </label>
    <label class="form-control min-w-[12rem]">
      <div class="label">
        <span class="label-text">Created through</span>
      </div>
      <input
        type="date"
        class="input input-bordered"
        [(ngModel)]="createdBefore"
      />
    </label>

    <div class="flex flex-col items-end justify-end gap-2 sm:flex-row">
      <button type="button" class="btn btn-primary" (click)="search()">
        Search
      </button>
      <button type="button" class="btn btn-neutral" (click)="clearFilters()">
        Clear
      </button>
      <button
        type="button"
        class="btn btn-neutral"
        [disabled]="loading || exporting || totalCount === 0"
        (click)="exportCsv()"
      >
        @if (exporting) {
          <span class="loading loading-spinner loading-sm"></span>
        }
        Export CSV
      </button>
    </div>
  </div>

  @if (error) {
    <div class="alert alert-error mb-4">{{ error }}</div>
  }

  @if (loading) {
    <div class="flex justify-center py-12">
      <span class="loading loading-spinner loading-lg"></span>
    </div>
  } @else {
    <div class="mb-4 text-sm opacity-80">
      {{ totalCount }} record(s) · page {{ currentPage }} of {{ totalPages }}
    </div>
    <div class="overflow-x-auto rounded-lg border border-base-content/20">
      <table
        class="table table-pin-rows"
        [ngClass]="{
          'table-lg': tableSpacing === 'comfortable',
          'table-md': tableSpacing === 'normal',
          'table-xs': tableSpacing === 'compact',
        }"
      >
        <thead>
          <tr>
            <th>Account #</th>
            <th>Product code</th>
            <th>Unique ID</th>
            <th>Expiration date</th>
            <th>Generation trigger</th>
            <th>Deactivated</th>
            <th>Created at</th>
            <th>Created by</th>
            <th class="w-[1%]"></th>
          </tr>
        </thead>
        <tbody>
          @for (row of rows; track row.id) {
            <tr [ngClass]="{ 'bg-base-200': $index % 2 === 0 }">
              <td>{{ row.tenant_account_number || '—' }}</td>
              <td>{{ row.product_code }}</td>
              <td>
                {{ row.unique_id || '—' }}
              </td>
              <td>
                {{ row.expiration_date | date: 'MM/dd/yyyy' : 'UTC' }}
              </td>
              <td>{{ row.generation_trigger | titlecase }}</td>
              <td>
                {{
                  row.deactivated_at
                    ? (row.deactivated_at | date: 'MM/dd/yyyy HH:mm')
                    : '—'
                }}
              </td>
              <td>{{ row.created_at | date: 'MM/dd/yyyy HH:mm' }}</td>
              <td>{{ row.created_by_email }}</td>
              <td class="w-[1%]">
                <span
                  class="inline-flex h-6 w-6 cursor-pointer items-center justify-center rounded-md hover:bg-base-300/60 hover:text-base-content/80"
                  [ngClass]="{
                    'text-xs': tableSpacing === 'comfortable',
                    'text-sm': tableSpacing === 'normal',
                    'text-base': tableSpacing === 'compact',
                  }"
                  (click)="toggleRow(row.id)"
                >
                  @if (expandedRowIds.has(row.id)) {
                    <app-chevron-up-icon class="inline-block h-4 w-4" />
                  } @else {
                    <app-chevron-down-icon class="inline-block h-4 w-4" />
                  }
                </span>
              </td>
            </tr>
            @if (expandedRowIds.has(row.id)) {
              <tr [ngClass]="{ 'bg-base-200': $index % 2 === 0 }">
                <td colspan="9">
                  <div
                    class="flex justify-between"
                    [ngClass]="{
                      'text-xs': tableSpacing === 'compact',
                      'text-sm': tableSpacing === 'normal',
                      'text-base': tableSpacing === 'comfortable',
                    }"
                  >
                    <div>
                      <div class="text-xs font-bold text-base-content/60">
                        Request IP
                      </div>
                      <div class="break-words">
                        {{ row.request_ip }}
                      </div>
                    </div>
                    <div>
                      <div class="text-xs font-bold text-base-content/60">
                        Referer
                      </div>
                      <div class="break-words">
                        {{ row.referer }}
                      </div>
                    </div>
                    <div>
                      <div class="text-xs font-bold text-base-content/60">
                        User agent
                      </div>
                      <div class="break-words">
                        {{ row.user_agent }}
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            }
          } @empty {
            <tr>
              <td colspan="7" class="text-center opacity-70">
                No activation keys found.
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>

    <app-pagination
      class="mt-6 block"
      [spacing]="tableSpacing"
      [pageSize]="pageSize"
      [currentPage]="currentPage"
      [totalPages]="totalPages"
      (pageChanged)="onPageChanged($event)"
      (settingsChanged)="saveSettings($event); search()"
    ></app-pagination>
  }
</div>
